import { useCallback } from 'react'
import { useSetSidepanelState } from '@renderer/overlay/atoms'
import { useSetSidepanelHotkeyOpened } from '@renderer/overlay/Sidepanel/atoms'
import { MEETING_VIEW_ID } from '@renderer/overlay/Sidepanel/components/meeting/meeting-view-id'
import { useLiveMeetingIdentity } from '@renderer/overlay/Sidepanel/components/meeting/use-live-meeting-identity'
import { useViewActions } from '@renderer/overlay/Sidepanel/view-atoms'
import type { MeetingTab } from '@renderer/overlay/Sidepanel/views/meeting-view/meeting-tabs'
import type { MeetingViewContext } from '@renderer/overlay/Sidepanel/views/meeting-view/use-meeting-view-model'
import { trackSidepanelOpened } from '@renderer/overlay/utils/track-sidepanel'

/** Opens the sidepanel from the Mini, on the given meeting. */
export function useOpenMeetingInSidepanel(): (meeting: MeetingViewContext) => void {
  const { openView } = useViewActions()
  const setSidepanelState = useSetSidepanelState()
  const setHotkeyOpened = useSetSidepanelHotkeyOpened()

  return useCallback(
    (meeting: MeetingViewContext) => {
      trackSidepanelOpened('mini')
      setHotkeyOpened(true)
      setSidepanelState('open')
      openView(MEETING_VIEW_ID, meeting)
    },
    [openView, setHotkeyOpened, setSidepanelState],
  )
}

/** Opens the sidepanel from the Mini, on the meeting being recorded. */
export function useOpenLiveMeetingInSidepanel(): (initialTab?: MeetingTab) => void {
  const liveMeeting = useLiveMeetingIdentity()
  const openMeeting = useOpenMeetingInSidepanel()

  return useCallback(
    (initialTab?: MeetingTab) => openMeeting(initialTab ? { ...liveMeeting, initialTab } : liveMeeting),
    [liveMeeting, openMeeting],
  )
}
